// extracted by mini-css-extract-plugin
module.exports = {"container":"_a946155e","results":"_d6f99f83","searchSuggestions":"_812e64e8"};